import React, { useState, useEffect } from 'react';
import { Sun, Cloud, CloudSun, CloudFog, CloudDrizzle, CloudRain, CloudSnow, CloudLightning } from 'lucide-react';
import { TYPO, S, R, SHADCN } from '../theme';

// ── <WeatherBadge> — météo du jour (Bordeaux) ───────────────────────────────
// Open-Meteo, gratuit et sans clé — appelé directement depuis le front pour
// ne pas consommer une fonction serverless (12/12 sur le plan Hobby).
// Icône + température actuelle, min/max du jour en tooltip. Refresh 30 min.

const LAT = 44.8378, LON = -0.5792; // Bordeaux

// Codes météo WMO → icône lucide + libellé
const wmo = (code) => {
  if (code === 0)               return { Icon: Sun,            label: 'Ciel dégagé' };
  if (code === 1 || code === 2) return { Icon: CloudSun,       label: 'Partiellement nuageux' };
  if (code === 3)               return { Icon: Cloud,          label: 'Couvert' };
  if (code === 45 || code === 48) return { Icon: CloudFog,     label: 'Brouillard' };
  if (code >= 51 && code <= 57) return { Icon: CloudDrizzle,   label: 'Bruine' };
  if ((code >= 61 && code <= 67) || (code >= 80 && code <= 82)) return { Icon: CloudRain, label: 'Pluie' };
  if ((code >= 71 && code <= 77) || code === 85 || code === 86) return { Icon: CloudSnow, label: 'Neige' };
  if (code >= 95)               return { Icon: CloudLightning, label: 'Orage' };
  return { Icon: Cloud, label: 'Météo' };
};

export default function WeatherBadge() {
  const [meteo, setMeteo] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const url = `https://api.open-meteo.com/v1/forecast?latitude=${LAT}&longitude=${LON}`
          + '&current=temperature_2m,weather_code'
          + '&daily=temperature_2m_max,temperature_2m_min'
          + '&timezone=Europe%2FParis&forecast_days=1';
        const res  = await fetch(url);
        const json = await res.json();
        if (!alive || !json.current) return;
        setMeteo({
          temp: Math.round(json.current.temperature_2m),
          code: json.current.weather_code,
          min:  Math.round(json.daily?.temperature_2m_min?.[0]),
          max:  Math.round(json.daily?.temperature_2m_max?.[0]),
        });
      } catch { /* silencieux — le badge n'apparaît pas si l'API est injoignable */ }
    };
    load();
    const timer = setInterval(load, 30 * 60 * 1000);
    return () => { alive = false; clearInterval(timer); };
  }, []);

  if (!meteo) return null;

  const { Icon, label } = wmo(meteo.code);
  return (
    <div
      title={`${label} — Bordeaux · min ${meteo.min}° / max ${meteo.max}°`}
      style={{
        display: 'flex', alignItems: 'center', gap: S[1],
        padding: `${S[1]}px ${S[2]}px`, borderRadius: R.pill,
        color: SHADCN.mutedFg, flexShrink: 0, cursor: 'default',
      }}
    >
      <Icon size={15} strokeWidth={1.7} />
      <span style={{ ...TYPO.caption, ...TYPO.num, color: SHADCN.fg }}>{meteo.temp}°</span>
    </div>
  );
}
